function cs(s1, s2)
{
	if (document.selection) {
		var str = document.selection.createRange();
		var s = document.F1.text.value;
		if (s1 == '//') {
			if ((str.text != "") && (s.indexOf(str.text)<0)) {
				var str2 = '> ';
				var j = 0;
				for(var i=0; i<str.text.length; i++) {
					str2 += str.text.charAt(i); j++;
					if (str.text.charAt(i) == "\n") { str2 += "> "; j=0; }
					if ((j>55)&&(str.text.charAt(i) == ' ')) { str2 += "\n> "; j=0; }
				}
				document.F1.text.value = s+"<I>\n"+str2+"\n</I>\n";
			} else {
				alert("Не выделен текст!\nДля вставки цитаты, сначала выделите на странице нужный текст, а затем нажмите эту кнопку.");
			}
		} else {
			if ((str.text != "") && (s.indexOf(str.text)>=0)) {
				if (str.text.indexOf(s1) == 0) {return '';}
				str.text = s1+str.text+s2;
			} else { document.F1.text.value = s+s1+s2; }
		}
	}
	document.F1.text.focus();
	return false;
}

/**
 *
 * @param title
 * @param url
 * @returns {boolean}
 */
function moderatorAddCommentPost(title, url) {
    $("#moderator_add_comment").dialog({
        title: title,
        width: 600,
        create: function() {
            var form = $(this);
            form.attr('action', url);
        }
    });

    return false;
}

/**
 *
 * @param title
 * @param postUrl
 * @param url
 * @returns {boolean}
 */
function moderatorEditPost(title, postUrl, url) {
    var elem = $(event.target);

    var post_text = elem.closest('.one_post').find('.post_body').html();
    if (!post_text) {
        alert('Запись была удалена модератором.');
        return false;
    }

    $.get(postUrl, function(data) {
        $("#moderator_edit_post").dialog({
            title: title,
            width: 600,
            create: function() {
                var form = $(this);
                form.attr('action', url);
                form.find('textarea:eq(0)').text(data.post.body_unformatted);
            }
        });

    }, 'json');

    return false;
}

function stateChange() {
	if ($(event.target).val()){
		location.href = $(event.target).val();
	}
}

function transferTopic() {
    if ($(event.target).val()){
        location.href = $(event.target).val();
    }
}

function cs(s1, s2)
{
    if (document.selection || document.getSelection) {
        var selection = GetSelection('textarea_body');
        var textarea  = document.getElementById('textarea_body');
        var value     = textarea.value;
        if ((selection != "") && (value.indexOf(selection)>=0)) {

            if (selection.indexOf(s1) == 0)
                return '';

            textarea.value  = value.substr(0, value.indexOf(selection));
            textarea.value += s1+selection+s2;
            textarea.value += value.substr(value.indexOf(selection)+selection.length);
        } else {
            textarea.value = value+s1+s2;
        }
    }
    textarea.focus();
    return false;
}

function GetSelection (element_id) {
    var selection = "";

    var textarea = document.getElementById(element_id);
    if ('selectionStart' in textarea) {
            // check whether some text is selected in the textarea
        if (textarea.selectionStart != textarea.selectionEnd) {
            selection = textarea.value.substring  (textarea.selectionStart, textarea.selectionEnd);
        }
    }
    else {  // Internet Explorer before version 9
            // create a range from the current selection
        var textRange = document.selection.createRange();
            // check whether the selection is within the textarea
        var rangeParent = textRange.parentElement ();
        if (rangeParent === textarea) {
            selection = textRange.text;

        }
    }
    return selection;
}

function addSurveyOption(){
    var count_options = $('#options > div').length;
    var option = $('<div />')
        .append('Вариант ' + (count_options+1) + ': ')
        .append('<input size="50" maxlength="50" name="options['+count_options+']" type="text">');

    $('#options').append(option);
    return false;
}

function removeLastSurveyOption(){
    if ($('#options > div').length > 2)
        $('#options > div').last().remove();

    return false;
}
